export const PUBLIC_LAYOUT_X_PADDING = 'px-8'

export const PUBLIC_LAYOUT_TOP_PADDING = 'pt-9'
